export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-social-amazon-f978507168e6e17139147ff8286da4a3.svg";